import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { FormService } from 'app/services/form.service';
import * as moment from 'moment';

@Component({
  selector: 'app-phase-one-trial-date',
  templateUrl: './phase-one-trial-date.component.html',
  styleUrls: ['./phase-one-trial-date.component.scss'],
})
export class PhaseOneTrialDateComponent implements OnInit {
  phase1ClinicalTrialStartDate!: Date | undefined;

  constructor(private formService: FormService) {}

  ngOnInit(): void {
    this.phase1ClinicalTrialStartDate = this.currentFormValueAsDate;
  }

  public updatePhase1ClinicalTrialStartDate(update: boolean, event: MatDatepickerInputEvent<Date>) {
    if(!update) {
      return;
    }

    if (event.value) {
      this.phase1ClinicalTrialStartDate = event.value;
    } else {
      this.phase1ClinicalTrialStartDate = undefined;
    }
    
    this.currentForm.patchValue({'phase1ClinicalTrialStartDate' : this.convertDateToString(this.phase1ClinicalTrialStartDate)});
    this.errorCheck();
  }
  
  private errorCheck() {
    const targetControl = this.currentForm.get('phase1ClinicalTrialStartDate');
    
    if(!targetControl) {
      return;
    }
    
    // Force re-validation
    setTimeout(() => {
      targetControl.markAsTouched();
      targetControl.markAsDirty();
      targetControl.updateValueAndValidity();
    });
  }

  get currentForm(): FormGroup {
    return this.formService.getCurrentUsanFormValue();
  }

  get currentFormValueAsDate(): Date | undefined {
    return this.convertStringToDate(this.currentForm.get('phase1ClinicalTrialStartDate')?.value);
  }

  public hasErrors(): boolean {
    const control = this.currentForm.get('phase1ClinicalTrialStartDate');
    if(!control || (!control.touched && !control.dirty && !this.formService.isShowingErrorSections)) {
      return false;
    }

    if(this.formService.hasFieldValidationError('phase1ClinicalTrialStartDate', 'required')) {
      return true;
    }

    const value: string = this.convertDateToString(control.value);
    if(value === null || value === undefined || !value.match(/^[01]?\d\/[0123]?\d\/[12]\d{3}$/)) {
      return true;
    }

    return false;
  }

  private convertStringToDate(date: string): Date | undefined {
    if(!date) {
      return undefined;
    }

    return moment(date, ['MM/DD/YYYY', 'MM-DD-YYYY', 'YYYY-MM-DD']).toDate();
  }

  private convertDateToString(date: Date | undefined): string {
    if(!date) {
      return '';
    }
    return moment(new Date(date), moment.ISO_8601).format('MM/DD/YYYY');
  }
}
